import React, { useState } from 'react';
import classNames from 'classnames';
import { Col, Row } from 'reactstrap';
import { IconButton } from '../../../../../components/IconButton';
import { PageTitle } from '../../../../../components/PageTitle';
import { Alert, AlertObject, AlertType } from '../../../../../components/Alert';
import { BulkActionButtons } from './BulkActionButtons';
import { AccountIntegration } from '../../../../../entities/AccountIntegration';
import { User } from '../../../../../entities/User';
import { HrisEmployee } from '../../../../../entities/applicant_tracking/HrisEmployees';
import { HrisProvider } from '../../../../../enums/IntegrationProvider/HrisProvider';
import { NewListCandidate } from '../../../../../entities/v1/applicant_tracking/NewListCandidate';

export interface AlertMessage {
  type: string;
  name: string;
}

interface PropTypes {
  alertMessage: AlertMessage;
  candidates: NewListCandidate[];
  currentUser: User;
  selectedCandidates: NewListCandidate[];
  addCandidateEnabled: boolean;
  emailAccountIntegration: AccountIntegration;
  reloadPage: () => void;
  setAlert: (alert: AlertObject) => void;
  hrisEmployees: HrisEmployee[];
  hrisProvider?: HrisProvider;
}

export function ListApplicationsPageHeader(props: PropTypes) {
  const [alertActive, setAlertActive] = useState<boolean>(
    props.alertMessage !== null,
  );

  return (
    <Row className='mb-4 align-items-center justify-content-between'>
      {alertActive && (
        <Alert
          type={AlertType.Success}
          autoClearTimeout={4000}
          clearable={true}
          onClose={() => setAlertActive(false)}
        >
          <span>
            The candidate{' '}
            <span className='fw-bold'>{props.alertMessage.name}</span> was
            successfully {props.alertMessage.type}.
          </span>
        </Alert>
      )}
      <Col xs='auto'>
        <PageTitle text={'Candidates'} />
      </Col>
      <Col xs='auto'>
        {props.selectedCandidates.length > 0 && (
          <BulkActionButtons {...props} />
        )}
        <IconButton
          color='primary'
          iconName='bi-person-check'
          iconClass={'fs-4'}
          buttonClass={classNames('w-auto')}
          iconTextClass={classNames('fs-5', 'fw-normal')}
          buttonText='Add Candidate'
          onClick={() => {
            window.location.href = '/applicant_tracking/candidate_wizard';
          }}
          disabled={!props.addCandidateEnabled}
          analyticsId='add-candidate-button'
        />
      </Col>
    </Row>
  );
}
